import { render, staticRenderFns } from "./MypageOneTimePassCompletePage.vue?vue&type=template&id=6f436ead"
import script from "./MypageOneTimePassCompletePage.vue?vue&type=script&lang=ts"
export * from "./MypageOneTimePassCompletePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports